import { render, staticRenderFns } from "./menuDialog.vue?vue&type=template&id=5588c313&scoped=true"
import script from "./menuDialog.vue?vue&type=script&lang=js"
export * from "./menuDialog.vue?vue&type=script&lang=js"
import style0 from "./menuDialog.vue?vue&type=style&index=0&id=5588c313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588c313",
  null
  
)

export default component.exports